export class ActivitySummary {
  Id: number;
  ActivityId: string;
  ActivityName: string;
  WbsName: string;
  WbsPath: string;
  InternalStatus: string;
  PlannedLaborHours: number;
  EarnedLaborHours: number;
  PercentComplete: number;
}

export class JobSummary {
  JobId: number;
  JobName: string;
  WbsPath: string;
  PlannedLaborHours: number;
  EarnedLaborHours: number;
  ActivityCount: number;
  Activities: ActivitySummary[];
}

export class WbsSummary {
  WbsCategoryId: number;
  WbsCategoryName: string;
  PlannedLaborHours: number;
  EarnedLaborHours: number;
  ActivityCount: number;
  Jobs: JobSummary[];
  Activities: ActivitySummary[];
}

export class ComplianceReport {
  ProjectId: number;
  ProjectName: string;
  ProjectCode: string;
  TotalPlannedHours: number;
  TotalEarnedHours: number;
TotalEarnedshift: number;
  WbsSummaries: WbsSummary[];
}
